import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/Home.css';

const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const slides = [
    { src: '/images/hero-living-room.png', alt: t('home.livingRoomAlt') },
    { src: '/images/hero-team-living-room.png', alt: t('home.livingRoomTeamAlt') },
    { src: '/images/hero-kitchen.png', alt: t('home.kitchenAlt') },
    { src: '/images/hero-team-kitchen.png', alt: t('home.kitchenTeamAlt') },
    { src: '/images/hero-bedroom.png', alt: t('home.bedroomAlt') },
    { src: '/images/hero-team-bedroom.png', alt: t('home.bedroomTeamAlt') }
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((current) => (current + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const changeSlide = (direction) => {
    setActiveSlide((current) => (current + direction + slides.length) % slides.length);
  };
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero" style={{ backgroundImage: "url('/images/hero-team-kitchen.png')" }}>
        <video
          className="hero-video"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          poster="/images/hero-team-kitchen.png"
          aria-hidden="true"
        >
          <source src="/videos/tout-propre-cleaning-team.mp4" type="video/mp4" />
        </video>
        <div className="hero-slides" aria-hidden="true">
          {slides.map((slide, index) => (
            <div
              key={slide.src}
              className={`hero-slide ${index === activeSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${slide.src})` }}
              role="img"
              aria-label={slide.alt}
            />
          ))}
        </div>
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>{t('hero.title')}</h1>
          <p>{t('hero.subtitle')}</p>
          <button className="cta-button" onClick={() => navigate('/services')}>
            {t('hero.cta')}
          </button>
        </div>
        <button className="carousel-arrow carousel-arrow-left" onClick={() => changeSlide(-1)} aria-label={t('common.previousImage')}>&#8249;</button>
        <button className="carousel-arrow carousel-arrow-right" onClick={() => changeSlide(1)} aria-label={t('common.nextImage')}>&#8250;</button>
        <div className="carousel-dots" aria-label={t('common.chooseCarouselImage')}>
          {slides.map((slide, index) => (
            <button
              key={slide.src}
              className={`carousel-dot ${index === activeSlide ? 'active' : ''}`}
              onClick={() => setActiveSlide(index)}
              aria-label={t('common.showImage', { number: index + 1 })}
              aria-current={index === activeSlide ? 'true' : undefined}
            />
          ))}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-us">
        <h2>{t('home.whyChoose')}</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">⭐</div>
            <h3>{t('home.professionalTeam')}</h3>
            <p>{t('home.professionalTeamDesc')}</p>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon">💰</div>
            <h3>{t('home.transparentPricing')}</h3>
            <p>{t('home.transparentPricingDesc')}</p>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon">⏱️</div>
            <h3>{t('home.flexibleScheduling')}</h3>
            <p>{t('home.flexibleSchedulingDesc')}</p>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon">✅</div>
            <h3>{t('home.qualityGuarantee')}</h3>
            <p>{t('home.qualityGuaranteeDesc')}</p>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <h2>{t('home.howItWorks')}</h2>
        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>{t('home.browseServices')}</h3>
            <p>{t('home.browseServicesDesc')}</p>
          </div>

          <div className="step">
            <div className="step-number">2</div>
            <h3>{t('home.chooseDateTime')}</h3>
            <p>{t('home.chooseDateTimeDesc')}</p>
          </div>

          <div className="step">
            <div className="step-number">3</div>
            <h3>{t('home.getConfirmed')}</h3>
            <p>{t('home.getConfirmedDesc')}</p>
          </div>

          <div className="step">
            <div className="step-number">4</div>
            <h3>{t('home.enjoyCleanliness')}</h3>
            <p>{t('home.enjoyCleanlinessDesc')}</p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <h2>{t('home.testimonials')}</h2>
        <div className="testimonials-grid">
          <div className="testimonial">
            <p>“{t('home.testimonialOne')}”</p>
            <strong>— Sarah M.</strong>
          </div>

          <div className="testimonial">
            <p>“{t('home.testimonialTwo')}”</p>
            <strong>— John D.</strong>
          </div>

          <div className="testimonial">
            <p>“{t('home.testimonialThree')}”</p>
            <strong>— Maria L.</strong>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
